import { BenefitType, ReferentPriceType, USState } from '@strata/constants';
import { ReferralStatusIndicator } from '@strata/react-status-indicators';

import { PendingReferralStatus } from 'services/constants';
import { AppThunk } from 'store';
import { ReferralValueCase } from 'store/api/performanceApi';
import {
    setPendingReferralData,
    setPendingReferralStatus,
} from 'store/wonReferrals/wonReferralListSlice';
import { fetchWorklistToDoTaskCount } from 'store/worklist/worklistThunks';

export interface SocketPendingReferral {
    referral_id: string;
    payer_id: string;
    segment_id: string;
    product_service_oid: string;
    product_service_description: string;
    product_qty: string;
    member_city: string;
    member_state: USState;
    member_zip: string;
    member_age: number;
    default_rate: string;
    referent_price_type: ReferentPriceType;
    price_is_frozen: boolean;
    price_source: string;
    incentive_total?: number;
    dx_name: string;
    prescriber_name: string;
    health_plan: string;
    segment_name: string;
    rx_refillcount: number;
    strength: string;
    place_of_service: string;
    value_cases: ReferralValueCase[];
    referral_expiration: string;
    benefit: BenefitType;
    is_brand: boolean;
    friendly_id?: string;
    route_code: string;
    pending_expiration: string;
    supplier_npi?: string;
    offer_rate?: string;
}

export const updatePendingReferrals =
    (pendingReferrals: SocketPendingReferral[]): AppThunk =>
    (dispatch) => {
        const incomingReferrals = pendingReferrals.map((referral) => ({
            referralId: referral.referral_id,
            payerId: referral.payer_id,
            segmentId: referral.segment_id,
            productServiceOid: referral.product_service_oid,
            product: referral.product_service_description,
            healthPlan: referral.health_plan,
            segmentName: referral.segment_name,
            incentiveTotal: referral.incentive_total,
            routeCode: referral.route_code,
            referralStatus: ReferralStatusIndicator.Statuses.PENDINTAKE,
            valueCases: referral.value_cases,
            offerRate: referral.offer_rate,
            pendingExpiration: referral.pending_expiration,
            friendlyId: referral.friendly_id,
            benefit: referral.benefit?.trim() as BenefitType,
            placeOfService: referral.place_of_service?.trim(),
            isBrand: referral.is_brand,
            referentPriceType: referral.referent_price_type,
            priceIsFrozen: referral.price_is_frozen,
            priceSource: referral.price_source,
            referralExpiration: referral.referral_expiration,
            pendingStatus: PendingReferralStatus.PENDING,
            pendingAcceptedRate: undefined,
        }));
        dispatch(setPendingReferralData({ incomingReferrals }));

        dispatch(fetchWorklistToDoTaskCount());
    };

export const acceptPendingReferral =
    (referralId: string, pendingAcceptedRate?: string): AppThunk =>
    (dispatch) => {
        dispatch(
            setPendingReferralStatus({
                referralId,
                referralStatus: ReferralStatusIndicator.Statuses.PHARM, // TODO handle prospective pending referrals
                pendingStatus: PendingReferralStatus.ACCEPTED,
                pendingAcceptedRate,
            }),
        );
    };

export const declinePendingReferral =
    (referralId: string): AppThunk =>
    (dispatch) => {
        dispatch(
            setPendingReferralStatus({
                referralId,
                referralStatus: ReferralStatusIndicator.Statuses.PENDINTAKE,
                pendingStatus: PendingReferralStatus.DECLINED,
            }),
        );
    };
